import { render, staticRenderFns } from "./loadingScreen.vue?vue&type=template&id=16688428&"
import script from "./loadingScreen.vue?vue&type=script&lang=js&"
export * from "./loadingScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports